import React from 'react';
import styled from "styled-components";
import {
    SectionWrapper,
    SectionHeader,
    StyledSectionDescription,
    SectionContainer,
    SectionImageWrapper
} from './SectionStyles';
import { Image } from "UI-Dash-Commons-UI";

const Section1Image = require( '../images/screen1-app-logos.svg');
const Section1ImageAltText = 'logo';
const Section1ImageWidth = '92px';
const Section1ImageHeight = '37px';

const Section1ImageLaptop = require('../images/screen1-laptop.png');
const Section1ImageLaptopAltText = 'laptopImage';
const Section1ImageLaptopWidth = '253px';
const Section1ImageLaptopHeight = '150px';

const HeaderText = 'Everything you need to grow your mobile apps.';
const SectionDescriptionText = 'Maximize your monetization, supercharge your returns, and ignite the growth of your business — all in one place.';

const Section1: React.FunctionComponent = () => {

    return <SectionContainer>
        <SectionWrapper>
            <StyledSectionHeader>
                {HeaderText}
            </StyledSectionHeader>
            <StyledSectionDescription>
                {SectionDescriptionText}
            </StyledSectionDescription>
            <StyledSectionImageWrapper>
                <StyledImageWrapper>
                    <Image
                        alt={Section1ImageAltText}
                        src={Section1Image}
                        width={Section1ImageWidth}
                        height={Section1ImageHeight}
                    />
                </StyledImageWrapper>
                    <Image
                        alt={Section1ImageLaptopAltText}
                        src={Section1ImageLaptop}
                        width={Section1ImageLaptopWidth}
                        height={Section1ImageLaptopHeight}
                    />
            </StyledSectionImageWrapper>
        </SectionWrapper>
    </SectionContainer>;
};

const StyledSectionHeader = styled( SectionHeader )`
    margin: 52px 50px 12px 50px;
    line-height: 33px;
`;

const StyledSectionImageWrapper = styled( SectionImageWrapper )`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 34px 88px 88px 90px;
`;

const StyledImageWrapper = styled.div`
    margin-bottom: 28px;
`;

export default Section1;
